document.addEventListener("DOMContentLoaded", function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const section = () => (window.theme && theme.cart && theme.cart.drawerSection) || "cart-ajax";

  // A row that stands for several cart lines (snippets/iwa-cart-lines: the
  // "2nd product 20% off" discount splits two of one variant into two lines)
  // carries all their keys in data-keys. Returns them, or null for a plain row.
  function rowKeys(el) {
    const row = el && el.closest && el.closest("[data-keys]");
    const keys = row ? row.getAttribute("data-keys").split(",").filter(Boolean) : [];
    return keys.length > 1 ? keys : null;
  }

  // The whole quantity goes on the first line and the others are set to 0;
  // Shopify then splits the lines again for the discount. The response carries
  // the rebuilt drawer section, which both cart forms render (cart:build).
  function setRowQuantity(keys, qty) {
    const updates = {};
    keys.forEach((key, i) => { updates[key] = i === 0 ? qty : 0; });
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates, sections: section() }),
    })
      .then((res) => res.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent("cart:build", { detail: { sections: cart.sections } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        return cart;
      });
  }

  // Remove link in the cart drawer. Without this it followed
  // /cart/change?quantity=0 to the cart page; the theme's quantity handler
  // also ignores 0, so this is the drawer's only way to drop a line. A merged
  // row removes all its lines, on the cart page too (there a plain row still
  // follows the link).
  document.addEventListener("click", function (e) {
    const link = e.target.closest && e.target.closest(".cart__remove a");
    if (!link) return;
    const item = link.closest("[data-key]");
    if (!item) return;
    const keys = rowKeys(item);
    if (!keys && !link.closest("#CartDrawer")) return;
    e.preventDefault();
    // Take the line out straight away; the response carries the rebuilt
    // drawer section (items, totals), so no second request is needed.
    item.style.display = "none";
    const drawer = document.getElementById("CartDrawer");
    if (drawer && link.closest("#CartDrawer")) drawer.classList.add("is-updating");
    if (keys) {
      setRowQuantity(keys, 0).catch(() => { window.location = link.href; });
      return;
    }
    fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: item.dataset.key, quantity: 0, sections: section() }),
    })
      .then((res) => res.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent("cart:build", { detail: { sections: cart.sections } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      })
      .catch(() => { window.location = link.href; });
  });

  // Quantity buttons on a merged row: the theme (CartForm.quantityChanged)
  // would change only the first line to the row's total. Caught first (capture
  // on document) and sent for all the row's lines instead; 0 removes the row.
  ["cart:quantity.cart-cart-drawer", "cart:quantity.cart-page"].forEach((name) => {
    document.addEventListener(name, function (e) {
      const detail = e.detail || [];
      const keys = rowKeys(detail[2]);
      if (!keys) return;
      e.stopImmediatePropagation();
      const qty = Math.max(0, parseInt(detail[1], 10) || 0);
      if (detail[2]) detail[2].classList.add("is-loading");
      const drawer = document.getElementById("CartDrawer");
      if (drawer && detail[2] && detail[2].closest("#CartDrawer")) drawer.classList.add("is-updating");
      setRowQuantity(keys, qty).catch(() => { window.location.reload(); });
    }, true);
  });

  // The drawer as a dialog (S5). theme.js moves focus in on open and closes on
  // Escape; here Tab and Shift+Tab stay inside while it is open (theme.js only
  // wraps forwards), and when it closes, focus goes back to what opened it if
  // the theme didn't do that itself (it does for the bag icon; not after an
  // add to cart, where the Add to cart button opened it).
  const cartDrawer = document.getElementById("CartDrawer");
  if (cartDrawer) {
    let lastActivated = null;
    let returnTo = null;
    let wasOpen = cartDrawer.classList.contains("drawer--is-open");
    const remember = (e) => {
      const el = e.target.closest && e.target.closest("button, a[href], input, select, [role='button'], [tabindex]");
      if (el && !cartDrawer.contains(el)) lastActivated = el;
    };
    document.addEventListener("pointerdown", remember, true);
    document.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") remember(e); }, true);

    new MutationObserver(() => {
      const open = cartDrawer.classList.contains("drawer--is-open");
      if (open && !wasOpen) returnTo = lastActivated;
      if (!open && wasOpen) {
        const target = returnTo;
        setTimeout(() => {
          const active = document.activeElement;
          const lost = !active || active === document.body || cartDrawer.contains(active);
          if (lost && target && document.contains(target) && target.offsetParent !== null) {
            target.focus({ preventScroll: true });
          }
        }, 550);
      }
      wasOpen = open;
    }).observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Tab" || !cartDrawer.classList.contains("drawer--is-open")) return;
      // A quick view opened from the drawer sits above it and keeps its own focus.
      if (document.querySelector(".iwa-qv[open], .iwa-qv.is-open")) return;
      const focusable = Array.prototype.filter.call(
        cartDrawer.querySelectorAll("a[href], button:not([disabled]), input:not([type='hidden']):not([disabled]), select, textarea, summary, [tabindex]:not([tabindex='-1'])"),
        (el) => el.offsetParent !== null
      );
      if (!focusable.length) return;
      // -1: focus is on the drawer or its form (where theme.js puts it) or outside.
      const at = focusable.indexOf(document.activeElement);
      const inside = cartDrawer.contains(document.activeElement);
      if (e.shiftKey && at <= 0) {
        e.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!e.shiftKey && (at === focusable.length - 1 || !inside)) {
        e.preventDefault();
        focusable[0].focus();
      }
    }, true);
  }

  // While the bag is open, a drag that nothing inside it can scroll would
  // move the page underneath (iOS ignores overflow: hidden on the page for
  // touch). Let a drag through only when the drawer element under the
  // finger can still scroll that way; cancel everything else.
  let touchX = 0;
  let touchY = 0;
  document.addEventListener("touchstart", function (e) {
    if (e.touches.length !== 1) return;
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener("touchmove", function (e) {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer || !drawer.classList.contains("drawer--is-open") || e.touches.length !== 1) return;
    // A quick view opened from the drawer sits above it and scrolls itself.
    if (e.target.closest && e.target.closest(".iwa-qv")) return;
    const dx = e.touches[0].clientX - touchX;
    const dy = e.touches[0].clientY - touchY;
    const vertical = Math.abs(dy) >= Math.abs(dx);
    for (let el = e.target; el && el !== drawer && drawer.contains(el); el = el.parentElement) {
      const style = getComputedStyle(el);
      if (vertical && /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight + 1) {
        const atTop = el.scrollTop <= 0;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        if ((dy > 0 && !atTop) || (dy < 0 && !atBottom)) return;
      }
      if (!vertical && /(auto|scroll)/.test(style.overflowX) && el.scrollWidth > el.clientWidth + 1) return;
    }
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
});
